// extracted by mini-css-extract-plugin
export default {"labelContainer":"Label_labelContainer__-egkR","labelDiv":"Label_labelDiv__wW+9T","lableImage":"Label_lableImage__WngIS"};